module.exports = __webpack_public_path__ + "img/martech.be973458.png";